import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

import CustomAlert from "../components/CustomAlert";

import "../styles/JobApplication.css";

function JobApplications() {
  const location = useLocation();
  const { job } = location.state || {};

  const [selectedApply, setSelectedApply] = useState("");
  const [fileName, setFileName] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);

  const handleApplyClick = (item) => {
    setSelectedApply(item);
  };

  const [formData, setFormData] = useState({
    jobname: job.name,
    attachments: [],
    fname: "",
    lname: "",
    address: "",
    email: "",
    phonenumber: "",
    isOverEightteen: "",
    birthdate: "",
    dateAvailable: "",
    felony: "",
    felonyMessage: "",
    USCitizen: "",
    authUSWork: "",
    driversLicesnse: "",
    cdl: "",
    referral: "",
    referralMessage: "",
    prevEmployed: "",
    prevEmpMessage: "",
    prevEmpSuper: "",
    empOneName: "",
    empOneSuper: "",
    empOneEmail: "",
    empOneAddress: "",
    empOneNumber: "",
    empOneStart: "",
    empOneEnd: "",
    empOneResponsibilities: "",
    empOneReasonLeaving: "",
    empTwoName: "",
    empTwoSuper: "",
    empTwoEmail: "",
    empTwoAddress: "",
    empTwoNumber: "",
    empTwoStart: "",
    empTwoEnd: "",
    empTwoResponsibilities: "",
    empTwoReasonLeaving: "",
    heardMessage: "",
  });

  const [alert, setAlert] = useState({ message: "", visible: null });
  const [file, setFile] = useState(null);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value || "",
    });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableSubmit(true);
    try {
      // Create a new FormData object (if needed for additional file handling)
      const updatedFormData = { ...formData };

      // If there's a file, convert it to base64
      if (file) {
        const base64File = await convertToBase64(file);
        updatedFormData.fileContent = base64File; // Add base64 file content to form data
        updatedFormData.fileName = file.name; // Add file name to form data
      }

      // Send the form data to the backend
      const response = await fetch(
        "https://uue59kk43b.execute-api.us-east-2.amazonaws.com/v1/application-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Ensure that the content-type is application/json
          },
          body: JSON.stringify(updatedFormData), // Ensure you stringify the form data
        }
      );

      const textResponse = await response.text();
      console.log(textResponse);

      if (response.ok) {
        setAlert({ message: "Application sent successfully!", visible: true });
        setFormData({
          jobname: job.name,
          attachments: [],
          fname: "",
          lname: "",
          address: "",
          email: "",
          phonenumber: "",
          isOverEightteen: "",
          birthdate: "",
          dateAvailable: "",
          felony: "",
          felonyMessage: "",
          USCitizen: "",
          authUSWork: "",
          driversLicesnse: "",
          cdl: "",
          referral: "",
          referralMessage: "",
          prevEmployed: "",
          prevEmpMessage: "",
          prevEmpSuper: "",
          empOneName: "",
          empOneSuper: "",
          empOneEmail: "",
          empOneAddress: "",
          empOneNumber: "",
          empOneStart: "",
          empOneEnd: "",
          empOneResponsibilities: "",
          empOneReasonLeaving: "",
          empTwoName: "",
          empTwoSuper: "",
          empTwoEmail: "",
          empTwoAddress: "",
          empTwoNumber: "",
          empTwoStart: "",
          empTwoEnd: "",
          empTwoResponsibilities: "",
          empTwoReasonLeaving: "",
          heardMessage: "",
        });
      } else {
        setAlert({ message: "Failed to send application.", visible: true });
      }
    } catch (error) {
      setAlert({ message: "Error sending application.", visible: true });
    }
    setDisableSubmit(false);
  };

  // Function to convert the file to base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // Remove base64 prefix (data:image/*;base64,)
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  useEffect(() => {
    if (alert.visible) {
      const timer = setTimeout(() => {
        setAlert({ message: "", visible: null });
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [alert.visible]);

  const handleDrop = (event) => {
    event.preventDefault();
    const selectedFile = event.dataTransfer.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault(); // Allow drop
    const selectedFile = event.dataTransfer.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  return (
    <>
      <div className="job-application-container">
        {alert.message && (
          <CustomAlert message={alert.message} visible={alert.visible} />
        )}
        {job ? (
          <>
            <div className="application-content">
              <div className="application-header">
                <h1 className="job-application-title">{job.name}</h1>
                <p className="job-application-crew">{job.crew}</p>

                {/* Close all applications */}
                {/* <p className="applications-closed-text">
                  Application will open after January 3, 2026.
                </p> */}
              </div>

              <div
                className={
                  selectedApply === "Apply"
                    ? "job-info-container active"
                    : "job-info-container"
                }
              >
                <div className="job-info-header">
                  <h3
                    className="apply-button"
                    onClick={() => handleApplyClick("Apply")}
                  >
                    Apply
                  </h3>
                </div>

                <div className="job-info">
                  {job.description !== "" ? (
                    <p className="job-desc">{job.description}</p>
                  ) : (
                    <p className="job-desc">
                      There is currently no job description.
                    </p>
                  )}

                  {/* Render Key Responsibilities */}
                  <ul className="job-details">
                    {job.keyResponsibilities &&
                    job.keyResponsibilities.length > 0 ? (
                      job.keyResponsibilities.map((section, index) => (
                        <li className="list-name" key={index}>
                          <h4>{section.name}</h4>
                          <ul>
                            {section.responsibilities?.map((resp, idx) => (
                              <li className="list-attributes" key={idx}>
                                <span className="attribute-title">
                                  {resp.title}
                                </span>{" "}
                                {resp.description}
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))
                    ) : (
                      <li>No specific operators available.</li>
                    )}
                    {/* Fallback */}
                  </ul>

                  {/* Render Specific Operators */}
                  <ul className="job-details">
                    {job.specificOperators &&
                    job.specificOperators.length > 0 ? (
                      job.specificOperators.map((section, index) =>
                        section.operators && section.operators.length > 0 ? (
                          <li className="list-name" key={index}>
                            <h4>{section.name}</h4>
                            <ul>
                              {section.operators.map((operator, idx) => (
                                <li className="list-attributes" key={idx}>
                                  <span>{operator.title}</span>{" "}
                                  {operator.description}
                                </li>
                              ))}
                            </ul>
                          </li>
                        ) : null
                      )
                    ) : (
                      <li>No specific operators available.</li>
                    )}
                  </ul>

                  {/* Render Skills and Qualifications */}
                  <ul className="job-details">
                    {job.skillsAndQualifications?.map((section, index) => (
                      <li className="list-name" key={index}>
                        <h4>{section.name}</h4>
                        <ul>
                          {section.qualifications?.map((qualification, idx) => (
                            <li className="list-attributes" key={idx}>
                              <span className="attribute-title">
                                {qualification.title}
                              </span>{" "}
                              {qualification.description}
                            </li>
                          ))}
                        </ul>
                      </li>
                    )) || <li>No skills and qualifications available.</li>}{" "}
                    {/* Fallback */}
                  </ul>

                  {/* Render Potential Work Environments */}
                  <ul className="job-details">
                    {job.potentialWorkEnvironments?.map((section, index) => (
                      <li className="list-name" key={index}>
                        <h4>{section.name}</h4>
                        <ul>
                          {section.environments?.map((environment, idx) => (
                            <li className="list-attributes" key={idx}>
                              {environment.description}
                            </li>
                          ))}
                        </ul>
                      </li>
                    )) || (
                      <li>No potential work environments available.</li>
                    )}{" "}
                    {/* Fallback */}
                  </ul>
                </div>
              </div>

              {/* MARK: Form */}

              <div
                className={
                  selectedApply === "Apply"
                    ? "form-application active"
                    : "form-application"
                }
              >
                <div className="job-info-header">
                  <h3
                    className="apply-button"
                    onClick={() => handleApplyClick("")}
                  >
                    Back
                  </h3>
                </div>
                <form className="form" onSubmit={handleSubmit}>
                  <div
                    className={`box-input ${fileName ? "file-selected" : ""}`}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                  >
                    <input
                      className="box-file"
                      type="file"
                      id="attachment"
                      name="attachment"
                      accept="application/pdf"
                      onChange={handleFileChange}
                    />
                    <label htmlFor="attachment">
                      <strong>Choose a resume</strong>
                      <span className="box-dragndrop">or drag it here</span>
                    </label>
                    {fileName && (
                      <div className="file-name">
                        <strong>Selected File:</strong> {fileName}
                      </div>
                    )}
                  </div>
                  <div className="input-container">
                    <label>First name:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="fname"
                      name="fname"
                      required
                      placeholder="Enter text here"
                      value={formData.fname}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Last name:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="lname"
                      name="lname"
                      required
                      placeholder="Enter text here"
                      value={formData.lname}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Address:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="address"
                      name="address"
                      required
                      placeholder="Enter text here"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Email:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="email"
                      name="email"
                      required
                      placeholder="email@example.com"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Phone Number:</label>
                    <input
                      className="input-box"
                      type="tel"
                      id="phone"
                      name="phonenumber"
                      // pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                      required
                      placeholder="(000)-000-0000"
                      value={formData.phonenumber}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Are you over the age of 18?</label>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-yes-1"
                        name="isOverEightteen"
                        value="yes" // Set the value to "yes"
                        checked={formData.isOverEightteen === "yes"}
                        onChange={handleChange} // Handle change
                      />
                      <label htmlFor="check-yes-1">Yes</label>
                    </div>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-no-1"
                        name="isOverEightteen"
                        value="no" // Set the value to "no"
                        checked={formData.isOverEightteen === "no"}
                        onChange={handleChange} // Handle change
                      />
                      <label htmlFor="check-no-1">No</label>
                      <br />
                    </div>
                  </div>

                  <div className="input-container">
                    <label>Birth Date:</label>
                    <input
                      type="date"
                      id="date"
                      name="birthdate"
                      required
                      className="input-box"
                      value={formData.birthdate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Date Available:</label>
                    <input
                      type="date"
                      id="date"
                      name="dateAvailable"
                      required
                      className="input-box"
                      value={formData.dateAvailable}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-container">
                    <label>Have you ever been convicted of a felony?</label>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-yes-2"
                        name="felony"
                        value="yes"
                        checked={formData.felony === "yes"}
                        onChange={handleChange}
                      />
                      <label for="check-yes-2">Yes</label>
                      <br />
                    </div>

                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-no-2"
                        name="felony"
                        value="no"
                        checked={formData.felony === "no"}
                        onChange={handleChange}
                      />
                      <label for="check-no-2">No</label>
                      <br />
                    </div>
                  </div>

                  {formData.felony === "yes" ? (
                    <div className="input-container">
                      <label>Please explain:</label>
                      <textarea
                        className="input-box textarea"
                        type="text"
                        id="felony-message"
                        name="felonyMessage"
                        placeholder="Enter text here"
                        value={formData.felonyMessage}
                        onChange={handleChange}
                      />
                    </div>
                  ) : null}

                  <div className="input-container">
                    <label>Are you a U.S. Citizen?</label>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-yes-3"
                        name="USCitizen"
                        value="yes"
                        checked={formData.USCitizen === "yes"}
                        onChange={handleChange}
                      />
                      <label for="check-yes-3">Yes</label>
                      <br />
                    </div>

                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-no-3"
                        name="USCitizen"
                        value="no"
                        checked={formData.USCitizen === "no"}
                        onChange={handleChange}
                      />
                      <label for="check-no-3">No</label>
                      <br />
                    </div>
                  </div>

                  <div className="input-container">
                    <label>Are you authorized to work in the U.S.?</label>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-yes-4"
                        name="authUSWork"
                        value="yes"
                        checked={formData.authUSWork === "yes"}
                        onChange={handleChange}
                      />
                      <label for="check-yes-4">Yes</label>
                      <br />
                    </div>

                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-no-4"
                        name="authUSWork"
                        value="no"
                        checked={formData.authUSWork === "no"}
                        onChange={handleChange}
                      />
                      <label for="check-no-4">No</label>
                      <br />
                    </div>
                  </div>

                  <div className="input-container">
                    <label>Do you have a valid Drivers License?</label>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-yes-5"
                        name="driversLicesnse"
                        value="yes"
                        checked={formData.driversLicesnse === "yes"}
                        onChange={handleChange}
                      />
                      <label for="check-yes-5">Yes</label>
                      <br />
                    </div>

                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-no-5"
                        name="driversLicesnse"
                        value="no"
                        checked={formData.driversLicesnse === "no"}
                        onChange={handleChange}
                      />
                      <label for="check-no-5">No</label>
                      <br />
                    </div>
                  </div>

                  {job.name === "CDL Driver Class A or B" ? (
                    <div className="input-container">
                      <label>Do you have a valid Class A/B CDL?</label>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="check-yes-7"
                          name="cdl"
                          value="yes"
                          checked={formData.cdl === "yes"}
                          onChange={handleChange}
                        />
                        <label for="check-yes-7">Yes</label>
                        <br />
                      </div>

                      <div className="radio-container">
                        <input
                          type="radio"
                          id="check-no-7"
                          name="cdl"
                          value="no"
                          checked={formData.cdl === "no"}
                          onChange={handleChange}
                        />
                        <label for="check-no-7">No</label>
                        <br />
                      </div>
                    </div>
                  ) : null}

                  <div className="input-container">
                    <label>Were you referred?</label>
                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-yes-6"
                        name="referral"
                        value="yes"
                        checked={formData.referral === "yes"}
                        onChange={handleChange}
                      />
                      <label for="check-yes-6">Yes</label>
                      <br />
                    </div>

                    <div className="radio-container">
                      <input
                        type="radio"
                        id="check-no-6"
                        name="referral"
                        value="no"
                        checked={formData.referral === "no"}
                        onChange={handleChange}
                      />
                      <label for="check-no-6">No</label>
                      <br />
                    </div>
                  </div>

                  {formData.referral === "yes" ? (
                    <div className="input-container">
                      <label>
                        Please enter the name of the person who referred you.
                      </label>
                      <textarea
                        className="input-box textarea"
                        type="text"
                        id="referral-message"
                        name="referralMessage"
                        placeholder="Enter text here"
                        value={formData.referralMessage}
                        onChange={handleChange}
                      />
                    </div>
                  ) : null}

                  <div className="input-container">
                    <div className="input-container">
                      <label>Have you worked for Jax Utilities before?</label>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="check-yes-6"
                          name="prevEmployed"
                          value="yes"
                          checked={formData.prevEmployed === "yes"}
                          onChange={handleChange}
                        />
                        <label for="check-yes-6">Yes</label>
                        <br />
                      </div>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="check-no-6"
                          name="prevEmployed"
                          value="no"
                          checked={formData.prevEmployed === "no"}
                          onChange={handleChange}
                        />
                        <label for="check-no-6">No</label>
                        <br />
                      </div>
                    </div>

                    {formData.prevEmployed === "yes" ? (
                      <>
                        <div className="input-container">
                          <label>
                            When did you work for us and what was your reasoning
                            for leaving?
                          </label>
                          <textarea
                            className="input-box textarea"
                            type="text"
                            id="employed-message"
                            name="prevEmpMessage"
                            placeholder="Enter text here"
                            value={formData.prevEmpMessage}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="input-container">
                          <label>
                            Who was your supervisor when you were here?
                          </label>
                          <textarea
                            className="input-box textarea"
                            type="text"
                            id="supervisor-message"
                            name="prevEmpSuper"
                            placeholder="Enter text here"
                            value={formData.prevEmpSuper}
                            onChange={handleChange}
                          />
                        </div>
                      </>
                    ) : null}

                    <div className="input-container">
                      <label>
                        How did you hear about the position you are applying
                        for?
                      </label>
                      <textarea
                        className="input-box textarea"
                        type="text"
                        id="heard-message"
                        name="heardMessage"
                        placeholder="Enter text here"
                        value={formData.heardMessage}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="application-header">
                    <h1 className="employment-title">Previous Employment</h1>
                    <p className="employment-description">
                      Please list your last two relevant job experiences. You
                      may attach a resume at the end of the application, but
                      complete this section as well.
                    </p>
                  </div>
                  {/* MARK: Employee 1 */}
                  <div className="input-container">
                    <label>#1 Emplyer Name:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="emp-one-name"
                      name="empOneName"
                      required
                      placeholder="Enter text here"
                      value={formData.empOneName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Supervisor name:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="super-one-name"
                      name="empOneSuper"
                      required
                      placeholder="Enter text here"
                      value={formData.empOneSuper}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Employer Address:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="emp-one-address"
                      name="empOneAddress"
                      required
                      placeholder="Enter text here"
                      value={formData.empOneAddress}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Employer Email:</label>
                    <input
                      className="input-box"
                      type="text"
                      id="emp-one-email"
                      name="empOneEmail"
                      required
                      placeholder="email@example.com"
                      value={formData.empOneEmail}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Phone Number:</label>
                    <input
                      className="input-box"
                      type="tel"
                      id="emp-one-phone"
                      name="empOneNumber"
                      //   pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                      required
                      placeholder="(000)-000-0000"
                      value={formData.empOneNumber}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Start Date:</label>
                    <input
                      type="date"
                      id="start-one-date"
                      name="empOneStart"
                      required
                      className="input-box"
                      value={formData.empOneStart}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>End Date:</label>
                    <input
                      type="date"
                      id="end-one-date"
                      name="empOneEnd"
                      required
                      className="input-box"
                      value={formData.empOneEnd}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Responsibilities:</label>
                    <textarea
                      className="input-box textarea"
                      type="text"
                      id="responsibilities-one-message"
                      name="empOneResponsibilities"
                      placeholder="Enter text here"
                      value={formData.empOneResponsibilities}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-container">
                    <label>Reason for leaving:</label>
                    <textarea
                      className="input-box textarea"
                      type="text"
                      id="leaving-one-message"
                      name="empOneReasonLeaving"
                      placeholder="Enter text here"
                      value={formData.empOneReasonLeaving}
                      onChange={handleChange}
                    />
                  </div>

                  {/* MARK: Employee 2 */}

                  <div className="employment-section">
                    <div className="input-container">
                      <label>#2 Emplyer Name:</label>
                      <input
                        className="input-box"
                        type="text"
                        id="emp-two-name"
                        name="empTwoName"
                        required
                        placeholder="Enter text here"
                        value={formData.empTwoName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Supervisor name:</label>
                      <input
                        className="input-box"
                        type="text"
                        id="super-two-name"
                        name="empTwoSuper"
                        required
                        placeholder="Enter text here"
                        value={formData.empTwoSuper}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Employer Address:</label>
                      <input
                        className="input-box"
                        type="text"
                        id="emp-one-address"
                        name="empTwoAddress"
                        required
                        placeholder="Enter text here"
                        value={formData.empTwoAddress}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Employer Email:</label>
                      <input
                        className="input-box"
                        type="text"
                        id="emp-two-email"
                        name="empTwoEmail"
                        required
                        placeholder="email@example.com"
                        value={formData.empTwoEmail}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Phone Number:</label>
                      <input
                        className="input-box"
                        type="tel"
                        id="emp-two-phone"
                        name="empTwoNumber"
                        //   pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                        required
                        placeholder="(000)-000-0000"
                        value={formData.empTwoNumber}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Start Date:</label>
                      <input
                        type="date"
                        id="start-two-date"
                        name="empTwoStart"
                        required
                        className="input-box"
                        value={formData.empTwoStart}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>End Date:</label>
                      <input
                        type="date"
                        id="end-two-date"
                        name="empTwoEnd"
                        required
                        className="input-box"
                        value={formData.empTwoEnd}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Responsibilities:</label>
                      <textarea
                        className="input-box textarea"
                        type="text"
                        id="responsibilities-two-message"
                        name="empTwoResponsibilities"
                        placeholder="Enter text here"
                        value={formData.empTwoResponsibilities}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label>Reason for leaving:</label>
                      <textarea
                        className="input-box textarea"
                        type="text"
                        id="leaving-two-message"
                        name="empTwoReasonLeaving"
                        placeholder="Enter text here"
                        value={formData.empTwoReasonLeaving}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="submit-button">
                    {disableSubmit ? (
                      <div className="submitting-wait-container">
                        <p className="submitting-wait">Submitting...</p>
                      </div>
                    ) : (
                      <input
                        type="submit"
                        value="Submit"
                        disabled={disableSubmit}
                      />
                    )}
                  </div>
                </form>
              </div>
            </div>
          </>
        ) : (
          <p>No job selected</p>
        )}
      </div>
    </>
  );
}

export default JobApplications;
